/**
 * Ui 그룹 브릿지 목데이터
 */

import type { UiGroup } from './types'

// Ui group mock responses
export const uiMocks: Record<keyof UiGroup, any> = {
  showProgress: null,
  dismissProgress: null,
  showAlert: { result: true },
  showConfirm: { result: true },
  showPopup: null,
  showPrepareView: null,
  showNetworkErrorView: null,
  showAdDetailBottomSheet: null,
  showCheckboxAlert: { isChecked: false, result: true }
}
